import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Activity, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function AdminGatePage() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [key, setKey] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { admin_key: key }, { withCredentials: true });
      await refresh();
      toast.success("Welcome, Platform Owner");
      nav("/app/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Invalid key");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6 dotted-bg">
      <div className="w-full max-w-md fade-up">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="size-12 rounded-lg bg-primary text-primary-foreground grid place-items-center">
            <ShieldCheck className="size-6" />
          </div>
          <div>
            <div className="font-bold text-2xl tracking-tight">Senrize Medical Flow</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Platform owner</div>
          </div>
        </div>

        <div className="bg-card border border-border rounded-xl p-8 shadow-sm">
          <h1 className="text-2xl font-bold tracking-tight">Owner access</h1>
          <p className="text-sm text-muted-foreground mt-1.5">
            Enter the platform access key to open the Super Admin Control Center.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-gate-form">
            <div className="space-y-2">
              <Label htmlFor="key" className="flex items-center gap-1.5">
                <KeyRound className="size-3.5" /> Access key
              </Label>
              <Input
                id="key"
                type="password"
                value={key}
                onChange={(e) => setKey(e.target.value)}
                placeholder="••••••••••••"
                required
                autoFocus
                className="h-11 mono"
                data-testid="admin-key-input"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11" data-testid="admin-gate-submit">
              {loading ? "Unlocking..." : "Unlock control center"}
            </Button>
          </form>

          <div className="mt-6 pt-6 border-t border-border text-center">
            <a href="/login" className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5">
              <Activity className="size-3" /> Regular staff sign-in
            </a>
          </div>
        </div>

        <p className="text-[11px] text-muted-foreground text-center mt-6">
          Access key is configured server-side. No username, no recovery — store it securely.
        </p>
      </div>
    </div>
  );
}
